import * as React from "react";
import {cx} from "emotion";

import "./flex-select.scss";

import {Radio}     from "@Common/ui-components/heavy/common/design2/radio/radio";
import {SelectRaw} from "@Common/ui-components/select-raw";

export const FlexSelect = ({key=undefined, list, className=undefined, valueToLabel = v=>v, isSelected = (e,i)=>false, onChange, placeholder=undefined}) => {
    const value = list && list.find(isSelected);
    if (list == null || list.length <= 1) {
        return (
            <div className={cx("flex-select-2d3 static", {placeholder: value == null})}>
                {value == null ? placeholder : valueToLabel(value)}
            </div>
        );
    } else if (list.length === 2) {
        return (
            <div className={cx("flex-select-2d3 radio")}>
                {list.map((e, i) => (
                    <div className="radio-line" key={i} onClick={() => onChange(e)}>
                        {Radio({selected: isSelected(e,i)})}

                        <div className="label">
                            {valueToLabel(e)}
                        </div>
                    </div>
                ))}
            </div>
        );
    } else {
        return SelectRaw({key, list, className, valueToLabel, isSelected, onChange, placeholder});
    }
};